// This icon file is generated automatically.
var RightFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 24 24", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.64 6.23A1 1 0 008 7v10a1 1 0 001.64.77l6-5a1 1 0 000-1.54l-6-5z" } }] }, "name": "right", "theme": "filled" };
export default RightFilled;
